import { cn } from '@costar-ui/cosmos'
import React from 'react'

import type { BodyProps } from './types'

const Body = React.forwardRef<HTMLTableSectionElement, BodyProps>(
  ({ className, ...props }, ref) => (
    <tbody
      ref={ref}
      className={cn('csg-tw-table-body', className)}
      {...props}
    />
  )
)
Body.displayName = 'TableBody'

export default Body
